import React from "react";

export const UserDataContext = React.createContext({
  groups: null,
  setGroups: () => {},
  user: null,
  setUser: () => {},
  reloadUserData: () => {},
});
